
const BasicDomainItems = [
    'a. 内科',
    'b. 小児科',
    'c. 皮膚科',
    'd. 精神科',
    'e. 外科',
    'f. 脳外科',
    'g. 整形外科',
    'h. 産婦人科',
    'i. 眼科',
    'j. 耳鼻咽喉科',
    'k. 泌尿器科',
    'l. 形成外科',
    'm. 放射線科',
    'n. 麻酔科',
    'o. リハビリテーション科',
    'p. 救急科',
    'q. 総合診療科',
    'r. 病理診断科',
    't. 臨床検査科',
    'u. 社会医学',
    'v. 歯科・口腔外科',
    'z. その他'
  ];

export default BasicDomainItems;
